import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_skill_link_RowClass } from "../../../dbschema";

export class BotSkillLinkContainerModel extends BaseContainerModel{
  alg_bot_skill_link: alg_bot_skill_link_RowClass = new alg_bot_skill_link_RowClass();
}
